import $console from '@zuto/utilities/src/$console'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'
import { fireReactGAEvent } from '../../components/Questions/utils'

const zutoAnalyticsHelper = new ZutoAnalyticsHelper()


export const zaSubmissionError = (experimentName: string, error: string) => {
  try {
    zutoAnalyticsHelper.sendCustomEventAsync({
      type: 'app-form',
      level: 'error',
      action: 'Failed to submit application',
      experiment: experimentName,
      message: error
    })
  } catch (e) {
    $console.error('Failed to send "submit application error" to ZA', e)
  }
}

type eventProps = { source: string, attribute: string, value?: any, origin: 'FormlessJourney' | 'isNullOrEmpty' }

export const zaPrefillAttributeMissing = ({ source, attribute, value, origin }: eventProps) => {
  fireReactGAEvent({
    category: origin,
    action: 'PrefillAttributeMissing',
    label: `Missing ${attribute} - ${value === '' ? 'value is empty' : 'value is null'}`,
    source
  })
  $console.error(`Missing ${attribute}, ${value ? 'value is' + value : ''}, origin: ${origin}`)
  try {
    zutoAnalyticsHelper.sendCustomEvent({
      eventType: 'PrefillAttributeMissing',
      eventCategory: origin,
      eventMessage: `Missing ${attribute}, ${value ? 'value is' + value : ''}, origin: ${origin}`,
      source
    })
  } catch (e) {
    $console.error('zutoAnalyticsHelper.sendCustomEvent error', e)
  }
}